import { ANONYMOUS, USER, COMPANY_ADMIN, REGULATOR, REGULATOR_ADMIN, SYS_ADMIN } from './roles';

export default function configurePermissions(AuthService, PermPermissionStore, PermRoleStore) {
  'ngInject';

  PermRoleStore.defineRole(ANONYMOUS, () => !AuthService.isLoggedIn);
  // eslint-disable-next-line max-len
  PermRoleStore.defineRole(USER, () => AuthService.isLoggedIn && !AuthService.isCompanyAdmin && !AuthService.isSysAdmin && !AuthService.isRegulator);
  PermRoleStore.defineRole(REGULATOR, () => AuthService.isRegulator);
  PermRoleStore.defineRole(REGULATOR_ADMIN, () => AuthService.isRegulatorAdmin);
  PermRoleStore.defineRole(COMPANY_ADMIN, () => AuthService.isCompanyAdmin);
  PermRoleStore.defineRole(SYS_ADMIN, () => AuthService.isSysAdmin);
}



// WEBPACK FOOTER //
// ./config/permissions/permissions.config.js